<script>
  import TableSlot from './slot'
  import { formatCell } from '@/utils/index'
  export default {
    name: 'RenderColumn',
    components: { TableSlot },
    inject: ['tableRoot'],
    props: {
      column: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {}
    },

    render() {
      const that = this

      // 自定义渲染
      function genCustomRender(column) {
        return (
          <el-table-column
            label={column.label}
            prop={column.prop}
            width={column.width}
            min-width={column['min-width']}
            fixed={column.fixed}
            align={column.align}
            showOverflowTooltip={column.showOverflowTooltip}
            scopedSlots={{
              default: ({ row, $index }) => {
                let config = column.config()
                let rules = config.rules
                let prop = `${that.tableRoot.prop}.${$index}.${column.prop}`
                let elem = ''
                switch (config.ctrl) {
                  case 'input':
                    elem = (
                      <v-input
                        prop={prop}
                        row={row}
                        config={config}
                        column={column}
                        rules={rules}
                      />
                    )
                    break
                  case 'select':
                    elem = (
                      <v-select
                        prop={prop}
                        row={row}
                        config={config}
                        column={column}
                        rules={rules}
                      />
                    )
                    break
                  case 'checkbox':
                    elem = (
                      <v-checkbox
                        prop={prop}
                        row={row}
                        config={config}
                        column={column}
                        rules={rules}
                      />
                    )
                    break
                  case 'radio':
                    break
                  case 'datepicker':
                    elem = (
                      <v-date-picker
                        prop={prop}
                        row={row}
                        config={config}
                        column={column}
                        rules={rules}
                      />
                    )
                    break
                }
                return elem
              },
            }}
          ></el-table-column>
        )
      }

      //   插槽
      function genSlot(column) {
        return (
          <el-table-column
            label={column.label}
            prop={column.prop}
            width={column.width}
            min-width={column['min-width']}
            fixed={column.fixed}
            sortable={column.sortable}
            align={column.align}
            showOverflowTooltip={column.showOverflowTooltip}
            scopedSlots={{
              default: ({ row, $index }) => {
                return (
                  <table-slot
                    row={row}
                    column={column}
                    index={$index}
                    parent={that}
                  ></table-slot>
                )
              },
            }}
          ></el-table-column>
        )
      }

      // 渲染展开项
      function genExpand(column) {
        // 展开项可以使用render函数，也可以使用插槽，使用插槽需声明 slot: 'expand',
        return (
          <el-table-column
            label={column.label}
            type="expand"
            scopedSlots={{
              default: ({ row, $index }) => {
                if (column.render) {
                  // 渲染函数
                  return column.render(row, column, $index)
                } else {
                  // 通过插槽渲染展开项
                  return (
                    <table-slot
                      row={row}
                      column={column}
                      index={$index}
                    ></table-slot>
                  )
                }
              },
            }}
          ></el-table-column>
        )
      }

      // 普通的表格
      function genCommonColumn(column) {
        return (
          <el-table-column
            label={column.label}
            prop={column.prop}
            type={column.type}
            width={column.width}
            min-width={column['min-width']}
            fixed={column.fixed}
            sortable={column.sortable}
            align={column.align}
            // selectable 只对仅对 type=selection 的列有效
            selectable={column.selectable}
            formatter={
              column.formatter
                ? column.formatter
                : (row, col, cellValue) => {
                    return formatCell(
                      cellValue,
                      column.config && column.config().type,
                      column.config && column.config().format
                    )
                  }
            }
          ></el-table-column>
        )
      }

      // 普通的表格
      function genChildrenColumn(column) {
        return (
          <el-table-column align={column.align} label={column.label}>
            {column.children.map((item) => {
              let columnConfig = Object.assign(
                {},
                item,
                that.tableRoot.defaultColumnConfig
              )
              return renderColumn(columnConfig)
            })}
          </el-table-column>
        )
      }

      // 普通的表格
      function genActionsColumn(column) {
        return (
          <el-table-column
            label={column.label}
            prop={column.prop}
            type={column.type}
            width={column.width}
            min-width={column['min-width']}
            fixed={column.fixed}
            scopedSlots={{
              default: ({ row, $index }) => {
                {
                  return column.actions.map((item) => {
                    return (
                      <el-button
                        icon={item.icon}
                        type={item.type}
                        on={{
                          click: () => {
                            if (item.click) {
                              item.click.call(
                                that,
                                that.tableRoot.tableData,
                                row,
                                $index
                              )
                            }
                          },
                        }}
                      >
                        {item.name}
                      </el-button>
                    )
                  })
                }
              },
            }}
          ></el-table-column>
        )
      }

      function renderColumn(column) {
        //可以展开列
        if (column.type === 'expand') {
          return genExpand(column)
        }

        //操作列
        if (column.type === 'actions') {
          return genActionsColumn(column)
        }

        //插槽
        if (column.slotScope) {
          return genSlot(column)
        }

        //自定义render
        if (column.config && column.config().ctrl) {
          return genCustomRender(column)
        }

        //带有子项目
        if (column.children) {
          return genChildrenColumn(column)
        }

        //普通项目
        return genCommonColumn(column)
      }

      const column = this.column
      return renderColumn(column)
    },
  }
</script>
